import * as React from 'react'

import Localization from '~/client/src/shared/localization/LocalizationManager'

import DefaultFilter from './DefaultFilter'
import DefaultGroupBy from './DefaultGroupBy'
import DefaultSort from './DefaultSort'
import SectionLabel from './SectionLabel'

export default function DefaultsSection(): JSX.Element {
  return (
    <div className="tw:flex tw:flex-col">
      <SectionLabel text={Localization.translator.setDefaults} />
      <div className="tw:flex tw:flex-wrap tw:gap-2">
        <DefaultSort />
        <DefaultGroupBy />
        <DefaultFilter />
      </div>
    </div>
  )
}
